module.exports = __webpack_public_path__ + "img/wemo-logo.97110ab0.png";